import { PortalErrorStateScheduleEnum } from '../portal-error-state-schedule.enum';

export enum FundingFormErrorStatesEnum {
  BankFundingFailed = PortalErrorStateScheduleEnum.FundingFormStatesStartIndex,
  FundingSucceed
}
